var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2758_2073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2758_2073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0496 17C24.8829 17 25.5913 16.7084 26.1746 16.125C26.7579 15.5417 27.0496 14.8334 27.0496 14C27.0496 13.1667 26.7579 12.4584 26.1746 11.875C25.5913 11.2917 24.8829 11 24.0496 11C23.2163 11 22.5079 11.2917 21.9246 11.875C21.3413 12.4584 21.0496 13.1667 21.0496 14C21.0496 14.8334 21.3413 15.5417 21.9246 16.125C22.5079 16.7084 23.2163 17 24.0496 17ZM24.0496 43.6L19.5996 39.25L21.9996 36L19.4496 32.45L21.3496 29.6V22.4C19.7496 21.7667 18.3496 20.7417 17.1496 19.325C15.9496 17.9084 15.3496 16.1334 15.3496 14C15.3496 11.5334 16.1829 9.46672 17.8496 7.80005C19.5163 6.13338 21.5829 5.30005 24.0496 5.30005C26.5163 5.30005 28.5829 6.13338 30.2496 7.80005C31.9163 9.46672 32.7496 11.5334 32.7496 14C32.7496 16.1334 32.1496 17.9084 30.9496 19.325C29.7496 20.7417 28.3496 21.7667 26.7496 22.4V40.9001L24.0496 43.6Z",
    fill: "#2D76FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyVertical);
export default __webpack_public_path__ + "static/media/key_vertical.ed44fe4b80ed3c0023bceda387f17f92.svg";
export { ForwardRef as ReactComponent };